import { render, staticRenderFns } from "./MoreProductsCarousel.vue?vue&type=template&id=4d8c3841&"
import script from "./MoreProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./MoreProductsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports